import React from 'react';
import { motion } from 'framer-motion';
import { CircleXIcon } from 'lucide-react';
const costs = ['Evenings lost searching for choreography ideas that actually work for your specific students', 'Classes that feel repetitive — because you keep going back to what you already know', 'Visible improvisation that silently chips away at your confidence as an instructor week after week', 'No real variety between sessions — and students who slowly lose motivation', 'Weekends spent planning instead of resting, recovering, or actually living your life'];
export function PainPoints() {
  return <section className="bg-navy px-4 py-20 text-white sm:py-24" data-id="element-143">
      <div className="mx-auto max-w-3xl" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-145">
          <p className="headline-kicker text-xs font-bold text-violet-light" data-id="element-146">
            THE PLANNING PROBLEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase sm:text-4xl" data-id="element-147">
            Does any of this sound familiar?
          </h2>
          <div className="mt-7 rounded-2xl border border-white/15 bg-navy-dark p-6 text-left text-base leading-relaxed text-slate-200" data-id="element-148">
            <p data-id="element-149">
              Sunday evening. 9 PM. You have a dance fitness class tomorrow
              morning.
            </p>
            <p className="mt-4" data-id="element-150">
              And you are still searching for choreography ideas, trying to
              build a routine that flows, fits your students, and feels
              energetic and professional.
            </p>
            <p className="mt-4 font-semibold text-violet-light" data-id="element-151">
              Not because you are not a great instructor. Because nobody ever
              gave you a complete, ready-to-teach system.
            </p>
            <p className="mt-4" data-id="element-152">
              You have been building every class from scratch. The time you
              should be resting, you spend planning.
            </p>
          </div>
        </motion.div>
        <div className="mt-10 space-y-3" data-id="element-153">
          {costs.map((item, index) => <motion.div key={item} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-white/15 bg-white/5 p-4 text-sm text-slate-200" data-id="element-154">
              <CircleXIcon size={18} className="mt-.5 shrink-0 text-violet-light" data-id="element-155" />
              {item}
            </motion.div>)}
        </div>
        <div className="mt-12 border-t border-white/15 pt-8 text-center" data-id="element-156">
          <p className="font-display text-2xl font-bold text-violet-light" data-id="element-157">
            Stop giving away your free time. What you need is the right tool.
          </p>
        </div>
      </div>
    </section>;
}